import React from 'react';
import './MaintenancePage.css';

const MaintenancePage: React.FC = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="maintenance-container">
      <div className="maintenance-content">
        <div className="maintenance-icon">??</div>
        <h1>System Maintenance</h1>
        <p className="maintenance-subtitle">We'll be back soon!</p>
        
        <div className="maintenance-message">
          <p>
            DotnetHub is currently undergoing scheduled maintenance.
          </p>
          <p>
            We're working hard to improve your experience.
          </p>
        </div>

        <div className="maintenance-status">
          <div className="status-item">
            <span className="status-icon">??</span>
            <span>Estimated downtime: ~15 minutes</span>
          </div>
          <div className="status-item">
            <span className="status-icon">??</span>
            <span>Services will resume automatically</span>
          </div>
        </div>

        <button 
          className="maintenance-refresh-btn" 
          onClick={handleRefresh}
        >
          ?? Check Status
        </button>

        <div className="maintenance-footer">
          <p>
            For urgent matters, contact: 
            <a href="mailto:support@dotnethub.pl"> support@dotnethub.pl</a>
          </p>
          <p className="maintenance-time">
            Last updated: {new Date().toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
